<template>
	<div class="col" gutter="20">
		<Title title="教學資源管理" />
		<SearchBar :searchText="searchText" @search="handleSearch" placeholder="名稱、步驟、目標" />

		<div class="row" align-x="between" align-y="center">
			<div class="row" align-y="center" gutter="20">
				<el-button @click="openDialog()" type="primary" icon="el-icon-plus" size="mini">上傳教學資源</el-button>
				<el-radio-group v-model="publishStatus" @change="statusChange" size="mini">
					<el-radio-button label="">全部</el-radio-button>
					<el-radio-button label="true">已發布</el-radio-button>
					<el-radio-button label="false">未發佈</el-radio-button>
				</el-radio-group>
			</div>
			<el-pagination v-if="dataList.total > 0" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10, 30, 50]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="dataList.total" />
		</div>

		<el-table :data="dataList.list">
			<el-table-column label="名稱" prop="title"></el-table-column>
			<el-table-column label="步驟" prop="step"></el-table-column>
			<el-table-column label="簡介" prop="brief">
				<pre slot-scope="{row}">{{row.brief}}</pre>
			</el-table-column>
			<el-table-column label="目標" prop="goal">
				<pre slot-scope="{row}">{{row.goal}}</pre>
			</el-table-column>
			<el-table-column label="狀態" align="center">
				<template slot-scope="{row}">
					<el-tag :type="row.published ? 'success' : 'info'">
						{{row.published ? '發布' : '草稿'}}
					</el-tag>
				</template>
			</el-table-column>
			<el-table-column label="操作">
				<template slot-scope="{row}">
					<el-button @click="openDialog(row)" type="text">編輯</el-button>
					<el-button @click="handleDatete(row.id)" icon="el-icon-delete" type="text" class="color-danger"></el-button>
				</template>
			</el-table-column>
		</el-table>

		<el-dialog title="上傳教學資源" :visible.sync="dialogVisible" v-loading.fullscreen.lock="loading" @close="closeDialog()" :close-on-click-modal="false" :close-on-press-escape="false">
			<el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-position="left" label-width="80px">
				<el-form-item label="名稱" prop="title">
					<el-input v-model="ruleForm.title"></el-input>
				</el-form-item>
				<el-form-item label="步驟" prop="step">
					<el-select v-model="ruleForm.step" placeholder="請選擇">
						<el-option value="感受" />
						<el-option value="想像" />
						<el-option value="實踐" />
						<el-option value="分享" />
						<el-option value="啟程：認識 DFC 四步驟" />
					</el-select>
				</el-form-item>
				<el-form-item label="簡介" prop="brief">
					<el-input v-model="ruleForm.brief" type="textarea" :autosize="{minRows: 3}" placeholder="30字以內"></el-input>
				</el-form-item>
				<el-form-item label="目標" prop="goal">
					<el-input v-model="ruleForm.goal" type="textarea" :autosize="{minRows: 3}" placeholder="30字以內"></el-input>
				</el-form-item>
				<el-form-item label="連結" prop="link">
					<el-input v-model="ruleForm.link"></el-input>
				</el-form-item>
				<!-- <el-form-item label="檔案" prop="file_list">
					<el-upload :action="postURL" :limit="1" :file-list="ruleForm.file_list" :on-success="handleUploadSuccess" :on-remove="handleRemove" :before-upload="handleUpload" :on-preview="handlePreview">
						<el-button :disabled="ruleForm.file_list.length > 0" type="primary" icon="el-icon-plus" size="mini">上傳</el-button>
					</el-upload>
				</el-form-item> -->
				<el-form-item>
					<div class="row" align-x="right">
						<el-button type="info" @click="handleSubmit(false)">暫存為草稿</el-button>
						<el-button type="success" @click="handleSubmit(true)">發布</el-button>
					</div>
				</el-form-item>
			</el-form>
			<el-dialog :visible.sync="innerDialogVisible" append-to-body>
				<img :src="previewURL" alt="" width="100%" />
			</el-dialog>
		</el-dialog>
	</div>
</template>

<script>
import Title from "@/components/backendManage/Title";
import SearchBar from "@/components/backendManage/SearchBar";
import { mapActions, mapState } from "vuex";
import API from "@/api";
import _ from "lodash";
import moment from "moment-timezone";

function fields() {
	return {
		title: '',
		goal: '',
		step: '',
		brief: '',
		link: '',
		file_list: []
	}
}

export default {
	components: { Title, SearchBar },
	data() {
		return {
			isNewPost: true,
			loading: false,
			dialogVisible: false,
			innerDialogVisible: false,
			previewURL: '',
			currentPage: 1,
			pageSize: 10,
			searchText: "",
			publishStatus: '',
			ruleForm: fields(),
			rules: {
				title: [{ required: true, message: '名稱', trigger: 'blur' }],
				goal: [{ required: true, message: '目標', trigger: 'blur' }],
				step: [{ required: true, message: '步驟', trigger: 'blur' }],
				brief: [{ required: true, message: '簡介', trigger: 'blur' }],
				link: [{ required: true, message: '連結', trigger: 'blur' }],
				file_list: [{ required: true, message: '檔案', trigger: 'blur' }]
			}
		};
	},
	computed: {
		...mapState('resource', ['dataList']),
		postURL() {
			return `${API.baseURL}/api/upload/image/edu-resource`;
		},
		query: {
			get() {
				return {
					page: this.currentPage,
					size: this.pageSize,
					text: this.searchText,
					published: this.publishStatus
				}
			},
			set({ page, size, text, published }) {
				if (page) this.currentPage = Number(page);
				if (size) this.pageSize = Number(size);
				if (text) this.searchText = text;
				if (published) this.publishStatus = JSON.parse(published);
			}
		}
	},
	watch: {
		async query(val) {
			await this.getResourceList(val);
			this.$router.replace({ query: this.query });
		}
	},
	methods: {
		...mapActions('resource', ['getResourceList', 'createResource', 'updateResource', 'deleteResource']),
		init() {
			if (this.$route.query) this.query = this.$route.query;
		},
		handleSearch(text) {
			this.searchText = text;
			this.currentPage = 1;
		},
		handleSizeChange(size) {
			this.pageSize = size;
			this.currentPage = 1;
		},
		handleCurrentChange(page) {
			this.currentPage = page;
		},
		statusChange(status) {
			this.currentPage = 1;
		},
		resetForm() {
			this.$refs['ruleForm'].clearValidate();
			this.ruleForm = fields();
		},
		openDialog(data) {
			if (data) this.ruleForm = data;
			this.isNewPost = data ? false : true;
			this.dialogVisible = true;
		},
		closeDialog() {
			this.resetForm();
			this.dialogVisible = false;
		},
		handleUpload(event, file, fileList) {
			this.loading = true;
		},
		handleUploadSuccess(response, file, fileList) {
			this.loading = false;
			this.ruleForm.file_list.push({ name: file.name, url: response.Location });
		},
		handleRemove(file, fileList) {
			this.ruleForm.file_list = fileList.map(file => new Object({
				name: file.name,
				url: file.url
			}));
		},
		handleSubmit(published) {
			this.$refs['ruleForm'].validate(async valid => {
				if (valid) {
					_.assign(this.ruleForm, { published });
					try {
						if (this.isNewPost) {
							await this.createResource({ query: this.query, data: this.ruleForm });
						} else {
							await this.updateResource({ query: this.query, data: this.ruleForm });
						}
						this.closeDialog();
					} catch (e) {
						this.$message.error(e);
					}
				}
			})
		},
		handleDatete(id) {
			this.$confirm('確定刪除？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(async () => {
				await this.deleteResource({ query: this.query, id });
				this.$message({
					type: 'success',
					message: '删除成功！'
				});
			}).catch(() => { });
		},
		handlePreview(file) {
			this.previewURL = file.url;
			this.innerDialogVisible = true;
		}
	},
	async created() {
		this.init();
		await this.getResourceList(this.query);
	}
};
</script>

<style lang="scss" scoped>
</style>